import { render, staticRenderFns } from "./ucusara.vue?vue&type=template&id=121dfff7&scoped=true&"
import script from "./ucusara.vue?vue&type=script&lang=js&"
export * from "./ucusara.vue?vue&type=script&lang=js&"
import style0 from "./ucusara.vue?vue&type=style&index=0&id=121dfff7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121dfff7",
  null
  
)

export default component.exports